<template>
    <div class="tw-flex tw-flex-col tw-w-full tw-h-full  tw-overflow-hidden">
        <div class="tw-flex tw-items-center tw-justify-between tw-flex-none tw-p-4">
            <b-form-input ref="searchInput" class=" tw-w-full" maxlength="20" v-model="searchValue" type="text"
                autocomplete="off" :placeholder="$t('请输入')" @change="handleSearch"></b-form-input>

            <span class="tw-flex-none tw-text-red-500 tw-text-sm tw-cursor-pointer tw-mr-1 tw-ml-4"
                @click.stop="handleCloseSearch">{{ $t('取消') }}</span>

        </div>

        <div class="tw-text-textLight tw-flex tw-flex-col tw-flex-1 tw-overflow-y-auto tw-px-4 tw-pb-20">
            <div class="tw-flex tw-items-center tw-justify-between tw-pb-3 tw-mt-1 tw-text-textInfo">
                <span>{{ $t('搜索历史') }}</span>
                <b-icon icon="trash" class="tw-w-4 tw-h-4 tw-ml-1 tw-cursor-pointer"
                    @click.stop="handleClearSearch"></b-icon>
            </div>
            <div class="tw-flex tw-flex-col">
                <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-py-4"
                    v-if="searchValues.length <= 0">
                    <span>{{ $t('暂无搜索历史') }}</span>
                </div>
                <div class="tw-flex tw-flex-col" v-else>
                    <span v-for="item in searchValues" :key="item" class="tw-text-sm tw-flex tw-py-2.5 "
                        @click.stop="handleHisSearch(item)">{{
                            item }}</span>
                </div>
            </div>
            <div class="tw-flex tw-items-center tw-pb-2 tw-mt-5 tw-text-primary">
                <span>{{ $t('热门搜索') }}</span>
            </div>
            <div class="tw-w-full tw-flex tw-items-center tw-justify-center tw-py-4"
                v-if="!hotSearch || hotSearch.length <= 0">
                <span>{{ $t('暂无热门搜索') }}</span>
            </div>
            <div class="tw-flex tw-flex-col" v-else>
                <span v-for="item in hotSearch" :key="item.keyword" class="tw-text-sm tw-flex tw-py-2.5"
                    @click.stop="handleHisSearch(item.keyword)">{{
                        item.keyword }}</span>
            </div>
        </div>


    </div>
</template>
<script>
import { hotSearchApi } from '@/api/modules/home'

export default {
    name: 'MobileSearch',
    data() {
        return {
            searchValue: '',
            isBlur: false,
            searchValues: [],
            hotSearch: []
        }
    },
    mounted() {
        this.getHotSearch()
        this.getSearchValues()
    },
    methods: {
        handleHisSearch(value) {
            this.$emit('onSearch', value)
            this.searchValue = value
            this.handleFilterSearch()
        },
        handleFilterSearch() {
            for (let i = 0; i < this.searchValues.length; i++) {
                if (this.searchValues[i] == this.searchValue) {
                    this.searchValues.splice(i, 1)
                    break
                }
            }
            this.searchValues.unshift(this.searchValue)
            if (this.searchValues.length > 10) {
                this.searchValues.pop()
            }
            localStorage.setItem('searchValues', JSON.stringify(this.searchValues))
            this.$emit('onSearch', this.searchValue)
        },
        handleSearch(value) {
            this.$refs.searchInput.blur()
            this.isBlur = false
            if (this.searchValue) {
                this.handleFilterSearch()
            }
        },
        getSearchValues() {
            this.searchValues = JSON.parse(localStorage.getItem('searchValues')) || [] || []
        },
        getHotSearch() {
            hotSearchApi().then(res => {
                this.hotSearch = res.data
            })
        },

        handleClearSearch() {
            this.searchValues = []
            localStorage.removeItem('searchValues')
        },
        handleCloseSearch() {
            this.$emit('onCloseSearch')
        }
    }
}
</script>
<style lang="scss" scoped></style>
